import { ScoreboardParticipant } from '../utils/types'

export const orderedParticipantIds = (
    scoresData: Record<string, number[]>,
    participants?: ScoreboardParticipant[],
  ): string[] => {
    const remaining = new Set(Object.keys(scoresData))
    const ordered: string[] = []
    participants?.forEach((p) => {
      const key = String(p.id)
      if (remaining.has(key)) {
        ordered.push(key)
        remaining.delete(key)
      }
    })
    remaining.forEach((id) => ordered.push(id))
    return ordered
  }
  
export const maxRoundCount = (scoresData: Record<string, number[]>): number => Math.max(0, ...Object.values(scoresData).map((arr) => arr?.length ?? 0))